/* eslint-disable no-unreachable, no-dupe-keys */

import {
    AUTH_ERROR,
    LOGIN_FAIL,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_UNVERIFIED,
    LOGIN_GOOGLE_REQUEST,
    LOGIN_GOOGLE_FAIL,
    LOGIN_GOOGLE_SUCCESS,
    LOGOUT,
    LOGOUT_FAILURE,
    LOGOUT_REQUEST,
    OTP_FAILURE,
    OTP_REQUEST,
    OTP_SUCCESS,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_FAILURE,
    REGISTER_FAIL,
    REGISTER_REQUEST,
    REGISTER_SUCCESS,
    RESEND_OTP_FAILURE,
    RESEND_OTP_REQUEST,
    RESEND_OTP_SUCCESS,
    USER_LOADED,
    VERIFY_OTP_FAILURE,
    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
    USER_PROFILE_REQUEST,
    USER_PROFILE_SUCCESS,
    USER_PROFILE_FAILURE,
    USER_PROFILE_UPLOAD_REQUEST,
    USER_PROFILE_UPLOAD_SUCCESS,
    USER_PROFILE_UPLOAD_FAILURE,
    USER_PROFILE_UPDATE_REQUEST,
    USER_PROFILE_UPDATE_SUCCESS,
    USER_PROFILE_UPDATE_FAILURE,
    USER_PROFILE_UPDATE_PURGE,
    USER_PROFILE_UPLOAD_PURGE,
    PAGE_DATA_REQUEST,
    PAGE_DATA_SUCCESS,
    PAGE_DATA_FAILURE,
    REGISTER_PURGE,
    OCCUPATION_REQUEST,
    OCCUPATION_SUCCESS,
    OCCUPATION_FAILURE,
    SPORT_REQUEST,
    SPORT_SUCCESS,
    SPORT_FAILURE,
    EXPIRE_OTP_REQUEST,
    EXPIRE_OTP_SUCCESS,
    EXPIRE_OTP_FAILURE,
    UPDATE_FCM_TOKEN_REQUEST,
    UPDATE_FCM_TOKEN_SUCCESS,
    UPDATE_FCM_TOKEN_FAILURE,
    RESET_OTP_STATE,
    RESET_PASSWORD_STATE

} from '../actions/types';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    loading: false,
    user: null,
    hasRegistered: false,
    hasRegisterPopup: false,
    isVerified: false,
    loginSuccess: false,
    profilePicture: '',
    profile: null,
    OTP: null,
    resentOTP: null,
    resetPasswordSuccess: false,
    resetPasswordRequest: false,
    resetPasswordFailure: false,
    expireOTPSuccess: false,
    logoutSuccess: false,
    otpSuccess: false,
    otpRequest: false,
    otpFailure: false,
    verifyOTPSuccess: false,
    resendOTPSuccess: false,

}

export default function auth(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case REGISTER_PURGE:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: null,
                hasRegistered: false
            }
            break;
        case REGISTER_SUCCESS:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: payload,
                hasRegistered: true,
                hasRegisterPopup: true
            }
            break;
        case LOGIN_SUCCESS:
        case LOGIN_GOOGLE_SUCCESS:
            localStorage.setItem('token', payload.access_token.token);
            localStorage.setItem('user', JSON.stringify(payload.user)); // TODO: Remove this line

            // Only set this if the backend says it's first login
            if (localStorage.getItem('isFirstLogin') && !localStorage.getItem('tourShown')) {
                localStorage.setItem('isFirstLogin', 'true');
            }

            return {
                ...state,
                token: payload.access_token.token,
                isAuthenticated: true,
                loading: false,
                user: payload,
                isVerified: true,
                loginSuccess: true,
                profilePicture: payload.user.image
            }
            break;
        case LOGIN_UNVERIFIED:
            // case LOGIN_GOOGLE_UNVERIFIED:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: payload,
                isVerified: false,
                loginSuccess: true,
                user: null
            }
            break;
        case OTP_REQUEST:
            return {
                ...state,
                otpRequest: true,
                otpSuccess: false,
                otpFailure: false,
                user: null
            }
            break;
        case OTP_SUCCESS:

            return {
                ...state,
                otpRequest: false,
                otpSuccess: true,
                otpFailure: false,
                user: payload
            }
            break;

        case RESET_OTP_STATE:

            return {
                ...state,
                otpRequest: false,
                otpSuccess: false,
                otpFailure: false,
                user: null
            }
            break;

        case RESET_PASSWORD_STATE:
            return {
                ...state,
                resetPasswordRequest: false,
                resetPasswordSuccess: false,
                resetPasswordFailure: false,
            }
            break;

        case PAGE_DATA_REQUEST:
            return {
                ...state,
                pageRequest: true,
                pageSuccess: false,
                pageFailure: false,
                page: null
            }
            break;
        case PAGE_DATA_SUCCESS:
            return {
                ...state,
                pageRequest: false,
                pageSuccess: true,
                pageFailure: false,
                page: payload
            }
            break;

        case PAGE_DATA_FAILURE:
            return {
                ...state,
                pageRequest: false,
                pageSuccess: false,
                pageFailure: true,
                page: null
            }
            break;
        case REGISTER_FAIL:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: null,
                hasRegistered: false
            }
            break;
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGIN_GOOGLE_FAIL:
            return {
                ...state,
                isAuthenticated: false,
                loading: false,
                user: payload,
                isVerified: false,
                loginSuccess: false,
            }
            break;
        case LOGOUT_REQUEST:
            return {
                ...state,
                logoutRequest: true,
                logoutSuccess: false,
                logoutFailure: false
            }
            break;
        case LOGOUT:
            return {
                ...initialState,
                token: null,
                page: state.page, // Preserve the page state
                logoutRequest: false,
                logoutSuccess: true,
                logoutFailure: false
            };
            break;
        case LOGOUT_FAILURE:
            return {
                ...state,
                logoutRequest: false,
                logoutSuccess: false,
                logoutFailure: true
            }
            break;
        case OTP_FAILURE:
            localStorage.removeItem('token');
            return {
                ...state,
                otpRequest: false,
                otpSuccess: false,
                otpFailure: true
            }
            break;
        case LOGIN_REQUEST:
        case REGISTER_REQUEST:
        case LOGIN_GOOGLE_REQUEST:
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: true,
                logoutSuccess: false
            }
            break;
        case PASSWORD_RESET_REQUEST:
            return {
                ...state,
                resetPasswordRequest: true,
                resetPasswordSuccess: false,
                resetPasswordFailure: false,
            }
            break;
        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                resetPasswordRequest: false,
                resetPasswordSuccess: true,
                resetPasswordFailure: false,
            }
            break;
        case PASSWORD_RESET_FAILURE:
            return {
                ...state,
                resetPasswordRequest: false,
                resetPasswordSuccess: false,
                resetPasswordFailure: true,
            }
            break;
        case VERIFY_OTP_REQUEST:
            return {
                ...state,
                verifyOTPRequest: true,
                verifyOTPSuccess: false,
                verifyOTPFailure: false,
            }
        case VERIFY_OTP_SUCCESS:
            localStorage.setItem('token', payload.data.access_token.token);
            localStorage.setItem('user', JSON.stringify(payload.data.user));
            return {
                ...state,
                token: payload.data.access_token.token,
                isAuthenticated: true,
                loading: false,
                user: payload,
                isVerified: true,
                verifyOTPRequest: false,
                verifyOTPSuccess: true,
                verifyOTPFailure: false,
                profilePicture: payload?.user?.image
            }

            break;
        case VERIFY_OTP_FAILURE:
            return {
                ...state,
                verifyOTPRequest: false,
                verifyOTPSuccess: false,
                verifyOTPFailure: true,
            }
            break;
        case USER_LOADED:
            localStorage.setItem('profile', JSON.stringify(payload.profile));
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                profile: payload.profile,
            }
        case RESEND_OTP_REQUEST:
            return {
                ...state,
                resendOTPRequest: true,
                resendOTPSuccess: false,
                resendOTPFailure: false,
                user: null
            }
        case RESEND_OTP_SUCCESS:
            return {
                ...state,
                resendOTPRequest: false,
                resendOTPSuccess: true,
                resendOTPFailure: false,
                user: payload
            }
        case RESEND_OTP_FAILURE:
            return {
                ...state,
                resendOTPRequest: false,
                resendOTPSuccess: false,
                resendOTPFailure: true,
                user: null
            }

        case USER_PROFILE_REQUEST:
            return {
                ...state,
                userProfileRequest: true,
                userProfileSuccess: false,
                userProfileFailure: false,
                userProfile: null,
            }
        case USER_PROFILE_SUCCESS:
            localStorage.setItem('user', JSON.stringify(payload.profile));
            return {
                ...state,
                userProfileRequest: false,
                userProfileSuccess: true,
                userProfileFailure: false,
                userProfile: payload.profile,
            }
        case USER_PROFILE_FAILURE:
            return {
                ...state,
                userProfileRequest: false,
                userProfileSuccess: false,
                userProfileFailure: true,
                userProfile: null,
            }

        case USER_PROFILE_UPLOAD_REQUEST:
            return {
                ...state,
                profileUploadRequest: true,
                profileUploadSuccess: false,
                profileUploadFailure: false,
                profileUpload: null,
            }
        case USER_PROFILE_UPLOAD_SUCCESS:
            return {
                ...state,
                profileUploadRequest: false,
                profileUploadSuccess: true,
                profileUploadFailure: false,
                profileUpload: payload,
            }
        case USER_PROFILE_UPLOAD_FAILURE:
            return {
                ...state,
                profileUploadRequest: false,
                profileUploadSuccess: false,
                profileUploadFailure: true,
                profileUpload: null,
            }
        case USER_PROFILE_UPLOAD_PURGE:
            return {
                ...state,
                profileUploadRequest: false,
                profileUploadSuccess: false,
                profileUploadFailure: false,
            }

        case USER_PROFILE_UPDATE_REQUEST:
            return {
                ...state,
                profileUpdateRequest: true,
                profileUpdateSuccess: false,
                profileUpdateFailure: false,
            }
        case USER_PROFILE_UPDATE_SUCCESS:
            return {
                ...state,
                profileUpdateRequest: false,
                profileUpdateSuccess: true,
                profileUpdateFailure: false,
            }
        case USER_PROFILE_UPDATE_FAILURE:
            return {
                ...state,
                profileUpdateRequest: false,
                profileUpdateSuccess: false,
                profileUpdateFailure: true,
            }
        case USER_PROFILE_UPDATE_PURGE:
            return {
                ...state,
                profileUpdateRequest: false,
                profileUpdateSuccess: false,
                profileUpdateFailure: false,
            }


        case OCCUPATION_REQUEST:
            return {
                ...state,
                occupationRequest: true,
                occupationSuccess: false,
                occupationFailure: false,
                occupations: null
            }
        case OCCUPATION_SUCCESS:
            return {
                ...state,
                occupationRequest: false,
                occupationSuccess: true,
                occupationFailure: false,
                occupations: payload
            }
        case OCCUPATION_FAILURE:
            return {
                ...state,
                occupationRequest: false,
                occupationSuccess: false,
                occupationFailure: true,
                occupations: null
            }

        case SPORT_REQUEST:
            return {
                ...state,
                sportRequest: true,
                sportSuccess: false,
                sportFailure: false,
                sports: null
            }
        case SPORT_SUCCESS:
            return {
                ...state,
                sportRequest: false,
                sportSuccess: true,
                sportFailure: false,
                sports: payload
            }
        case SPORT_FAILURE:
            return {
                ...state,
                sportRequest: false,
                sportSuccess: false,
                sportFailure: true,
                sports: null
            }
        case EXPIRE_OTP_REQUEST:
            return {
                ...state,
                expireOTPRequest: true,
                expireOTPSuccess: false,
                expireOTPFailure: false,
                expireOtpUser: null
            }
        case EXPIRE_OTP_SUCCESS:
            return {
                ...state,
                expireOTPRequest: false,
                expireOTPSuccess: true,
                expireOTPFailure: false,
                expireOtpUser: payload
            }
        case EXPIRE_OTP_FAILURE:
            return {
                ...state,
                expireOTPRequest: false,
                expireOTPSuccess: false,
                expireOTPFailure: true,
                expireOtpUser: null
            }
        case UPDATE_FCM_TOKEN_REQUEST:
            return {
                ...state,
                fcmtokenRequest: true,
                fcmtokenSuccess: false,
                fcmtokenFailure: false,
            }
        case UPDATE_FCM_TOKEN_SUCCESS:
            return {
                ...state,
                fcmtokenRequest: false,
                fcmtokenSuccess: true,
                fcmtokenFailure: false,
            }
        case UPDATE_FCM_TOKEN_FAILURE:
            return {
                ...state,
                fcmtokenRequest: false,
                fcmtokenSuccess: false,
                fcmtokenFailure: true,
            }
        default:
            return state
    }
}